import React from "react";
import i18next from "i18next";
import { ChangeLanguage, classNames } from "../../helpers";
import { AR_LANG, EN_LANG } from "../../i18n/index";
import { Fragment, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { GlobeAltIcon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";

type ChangeLangModalProps = {
  setOpen: any;
  open: any;
};
export default function ChangeLangModal({
  open,
  setOpen,
}: ChangeLangModalProps) {
  const cancelButtonRef = useRef(null);
  const LocalBasePath = "modal.changeLanguage";
  const { t } = useTranslation();
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="fixed z-50 inset-0 overflow-y-auto"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="relative inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="flex items-center mb-4">
                  <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-brandblue-100 sm:mx-0 sm:h-10 sm:w-10">
                    <GlobeAltIcon
                      className="h-6 w-6 text-brandblue-600"
                      aria-hidden="true"
                    />
                  </div>
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <Dialog.Title
                      as="h3"
                      className="text-lg leading-6 px-1 font-medium text-gray-900"
                    >
                      {t(`${LocalBasePath}.changeTheLanguage`)}
                    </Dialog.Title>
                  </div>
                </div>
                <button
                  onClick={() => {
                    ChangeLanguage(EN_LANG);
                    setOpen(false);
                  }}
                  className={classNames(
                    i18next.language === "en"
                      ? "bg-brandblue-500 text-white"
                      : "text-gray-600",
                    "block px-4 py-2 text-sm w-full rounded-md my-2"
                  )}
                >
                  English
                </button>
                <button
                  onClick={() => {
                    ChangeLanguage(AR_LANG);
                    setOpen(false);
                  }}
                  className={classNames(
                    i18next.language === "ar"
                      ? "bg-brandblue-500 text-white"
                      : "text-gray-700",
                    "block px-4 py-2 text-sm w-full rounded-md  my-2"
                  )}
                >
                  العربي
                </button>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={() => setOpen(false)}
                  ref={cancelButtonRef}
                >
                  {t(`${LocalBasePath}.cancel`)}
                </button>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
